import { CheckCircle, SlashCircle01, Tool02 } from "@untitledui/icons";
import type { QuestionOption } from "../hooks/useQuestionForm";

export const yesNoOptions: QuestionOption[] = [
	{ id: "yes", text: "Sim" },
	{ id: "no", text: "Não" },
];

export const defaultChecklistOptions: QuestionOption[] = [
	{ id: "regular", text: "Regular", icon: CheckCircle },
	{ id: "avariado", text: "Avariado", icon: Tool02 },
	{ id: "nao-possui", text: "Não possui", icon: SlashCircle01 },
];

/** Empty option slots for Seleção — labels filled by the user (placeholders in UI). */
export const createEmptySelectionOptions = (count = 4): QuestionOption[] =>
	Array.from({ length: count }, (_, index) => ({
		id: String(index + 1),
		text: "",
	}));
